function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
import { buildCustomerRequestObject } from '../helpers/customer.helper';
export var CREATE_HOUSEHOLD_CONSTANTS = {
  BEGIN: 'CREATE_HOUSEHOLD_BEGIN',
  SUCCESS: 'CREATE_HOUSEHOLD_SUCCESS',
  FAILURE: 'CREATE_HOUSEHOLD_FAILURE'
};
var CREATE_HOUSEHOLD_EVENTS = [CREATE_HOUSEHOLD_CONSTANTS.BEGIN, CREATE_HOUSEHOLD_CONSTANTS.SUCCESS, CREATE_HOUSEHOLD_CONSTANTS.FAILURE];
var createHouseholdPromise = function createHouseholdPromise(dispatch, customerId, household) {
  return ThunkHelper(dispatch, CREATE_HOUSEHOLD_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CreateHousehold',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Household: household
    }
  });
};
export var createHousehold = function createHousehold(customerId, household) {
  return function (dispatch) {
    return createHouseholdPromise(dispatch, customerId, household);
  };
};
export var CREATE_HOUSEHOLD_MEMBER_CONSTANTS = {
  BEGIN: 'CREATE_HOUSEHOLD_MEMBER_BEGIN',
  SUCCESS: 'CREATE_HOUSEHOLD_MEMBER_SUCCESS',
  FAILURE: 'CREATE_HOUSEHOLD_MEMBER_FAILURE'
};
var CREATE_HOUSEHOLD_MEMBER_EVENTS = [CREATE_HOUSEHOLD_MEMBER_CONSTANTS.BEGIN, CREATE_HOUSEHOLD_MEMBER_CONSTANTS.SUCCESS, CREATE_HOUSEHOLD_MEMBER_CONSTANTS.FAILURE];
export var createHouseholdMemberPromise = function createHouseholdMemberPromise(dispatch, customer, additionalOptions) {
  return ThunkHelper(dispatch, CREATE_HOUSEHOLD_MEMBER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CreateSubscriber',
    data: Object.assign(buildCustomerRequestObject(customer), additionalOptions)
  });
};
export var createHouseholdMember = function createHouseholdMember(customer) {
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return createHouseholdMemberPromise(dispatch, customer, additionalOptions);
  };
};
export var RETRIEVE_HOUSEHOLD_CONSTANTS = {
  BEGIN: 'RETRIEVE_HOUSEHOLDS_BEGIN',
  SUCCESS: 'RETRIEVE_HOUSEHOLDS_SUCCESS',
  FAILURE: 'RETRIEVE_HOUSEHOLDS_FAILURE'
};
var RETRIEVE_HOUSEHOLD_EVENTS = [RETRIEVE_HOUSEHOLD_CONSTANTS.BEGIN, RETRIEVE_HOUSEHOLD_CONSTANTS.SUCCESS, RETRIEVE_HOUSEHOLD_CONSTANTS.FAILURE];
export var retrieveCustomerHouseholdsPromise = function retrieveCustomerHouseholdsPromise(dispatch, customerId, includeRemoved) {
  return ThunkHelper(dispatch, RETRIEVE_HOUSEHOLD_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveHouseholds',
    data: {
      IncludeRemoved: includeRemoved
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveCustomerHouseholds = function retrieveCustomerHouseholds(customerId, includeRemoved) {
  return function (dispatch) {
    return retrieveCustomerHouseholdsPromise(dispatch, customerId, includeRemoved);
  };
};
export var SET_SELECTED_HOUSEHOLD_MEMBER = 'SET_SELECTED_HOUSEHOLD_MEMBER';
export var setSelectedHouseholdMember = function setSelectedHouseholdMember(memberId) {
  return {
    type: SET_SELECTED_HOUSEHOLD_MEMBER,
    payload: memberId
  };
};
export var SET_EDIT_HOUSEHOLD_DATA = 'SET_EDIT_HOUSEHOLD_DATA';
export var setEditHouseholdData = function setEditHouseholdData(household) {
  return {
    type: SET_EDIT_HOUSEHOLD_DATA,
    payload: household
  };
};
export var UPDATE_HOUSEHOLD_CONSTANTS = {
  BEGIN: 'UPDATE_HOUSEHOLD_BEGIN',
  SUCCESS: 'UPDATE_HOUSEHOLD_SUCCESS',
  FAILURE: 'UPDATE_HOUSEHOLD_FAILURE'
};
var UPDATE_HOUSEHOLD_EVENTS = [UPDATE_HOUSEHOLD_CONSTANTS.BEGIN, UPDATE_HOUSEHOLD_CONSTANTS.SUCCESS, UPDATE_HOUSEHOLD_CONSTANTS.FAILURE];
var updateHouseholdPromise = function updateHouseholdPromise(dispatch, customerId, household, status) {
  return ThunkHelper(dispatch, UPDATE_HOUSEHOLD_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateHousehold',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Household: household,
      Status: status
    }
  });
};
export var updateHousehold = function updateHousehold(customerId, household) {
  return function (dispatch) {
    return updateHouseholdPromise(dispatch, customerId, household);
  };
};
export var updateHouseholdAndStatus = function updateHouseholdAndStatus(customerId, household, status) {
  return function (dispatch) {
    return updateHouseholdPromise(dispatch, customerId, household, status);
  };
};
export var UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_CONSTANTS = {
  BEGIN: 'UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_BEGIN',
  SUCCESS: 'UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_SUCCESS',
  FAILURE: 'UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_FAILURE'
};
var UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_EVENTS = [UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_CONSTANTS.BEGIN, UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_CONSTANTS.SUCCESS, UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_CONSTANTS.FAILURE];
var updateHouseholdServicesAssociationsPromise = function updateHouseholdServicesAssociationsPromise(dispatch, data) {
  return ThunkHelper(dispatch, UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateHouseholdMemberToServices',
    data: {
      HouseholdMemberToService: {
        HeadOfHouseholdSubscriberId: data.headOfHouseholdSubscriberId,
        MemberToServiceAssociations: data.householdServicesAssociations
      }
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.subscriberId)
  });
};
export var updateHouseholdServicesAssociations = function updateHouseholdServicesAssociations(data) {
  return function (dispatch) {
    return updateHouseholdServicesAssociationsPromise(dispatch, data);
  };
};
export var REMOVE_HOUSEHOLD_MEMBERS_CONSTANTS = {
  BEGIN: 'REMOVE_HOUSEHOLD_MEMBERS_BEGIN',
  SUCCESS: 'REMOVE_HOUSEHOLD_MEMBERS_SUCCESS',
  FAILURE: 'REMOVE_HOUSEHOLD_MEMBERS_FAILURE'
};
var REMOVE_HOUSEHOLD_MEMBERS_EVENTS = [REMOVE_HOUSEHOLD_MEMBERS_CONSTANTS.BEGIN, REMOVE_HOUSEHOLD_MEMBERS_CONSTANTS.SUCCESS, REMOVE_HOUSEHOLD_MEMBERS_CONSTANTS.FAILURE];
export var removeHouseholdMembersPromise = function removeHouseholdMembersPromise(dispatch, customerId, householdId, members) {
  return ThunkHelper(dispatch, REMOVE_HOUSEHOLD_MEMBERS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateHouseholdMembers',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Id: householdId,
      HouseholdMembersToRemove: members.map(function (member) {
        return member.SubscriberId;
      }),
      HouseholdMembersToUpdate: members
    }
  });
};
export var removeHouseholdMembers = function removeHouseholdMembers(customerId, householdId, members) {
  return function (dispatch) {
    return removeHouseholdMembersPromise(dispatch, customerId, householdId, members);
  };
};
export var UPDATE_HOUSEHOLD_MEMBERS = {
  BEGIN: 'UPDATE_HOUSEHOLD_MEMBERS_BEGIN',
  SUCCESS: 'UPDATE_HOUSEHOLD_MEMBERS_SUCCESS',
  FAILURE: 'UPDATE_HOUSEHOLD_MEMBERS_FAILURE'
};
var UPDATE_HOUSEHOLD_MEMBERS_EVENTS = [UPDATE_HOUSEHOLD_MEMBERS.BEGIN, UPDATE_HOUSEHOLD_MEMBERS.SUCCESS, UPDATE_HOUSEHOLD_MEMBERS.FAILURE];
export var updateHouseholdMember = function updateHouseholdMember(subscriberId, householdId, member) {
  return function (dispatch) {
    return ThunkHelper(dispatch, UPDATE_HOUSEHOLD_MEMBERS_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/UpdateHouseholdMembers',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
      data: {
        Id: householdId,
        HouseholdMembersToUpdate: [member]
      }
    });
  };
};
export var SET_MEMBER_PRIVILEGE = 'SET_MEMBER_PRIVILEGE';
export var setMemberPrivilege = function setMemberPrivilege(payload) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: SET_MEMBER_PRIVILEGE,
      payload: payload
    }));
  };
};
export var RESET_MEMBER_PRIVILEGE_UI = 'RESET_MEMBER_PRIVILEGE_UI';
export var resetUiState = function resetUiState() {
  return {
    type: RESET_MEMBER_PRIVILEGE_UI
  };
};
export var SET_AVAILABLE_PAYMENT_INSTRUMENTS = 'SET_AVAILABLE_PAYMENT_INSTRUMENTS';
export var setAvailablePaymentInstruments = function setAvailablePaymentInstruments(payload) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: SET_AVAILABLE_PAYMENT_INSTRUMENTS,
      payload: payload
    }));
  };
};
export var SET_SELECTED_HOURS = 'SET_SELECTED_HOURS';
export var setSelectedHours = function setSelectedHours(payload, memberId) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: SET_SELECTED_HOURS,
      payload: payload,
      requestObject: {
        memberId: memberId
      }
    }));
  };
};
export var SET_SELECTED_HOURS_FOR_HOUSEHOLD_MEMBER = 'SET_SELECTED_HOURS_FOR_HOUSEHOLD_MEMBER';
export var setSelectedHoursForHouseholdMember = function setSelectedHoursForHouseholdMember(payload) {
  return {
    type: SET_SELECTED_HOURS_FOR_HOUSEHOLD_MEMBER,
    payload: payload
  };
};
export var REMOVE_HOUSEHOLD = {
  BEGIN: 'REMOVE_HOUSEHOLD_BEGIN',
  SUCCESS: 'REMOVE_HOUSEHOLD_SUCCESS',
  FAILURE: 'REMOVE_HOUSEHOLD_FAILURE'
};
var REMOVE_HOUSEHOLD_EVENTS = [REMOVE_HOUSEHOLD.BEGIN, REMOVE_HOUSEHOLD.SUCCESS, REMOVE_HOUSEHOLD.FAILURE];
export var removeHousehold = function removeHousehold(subscriberId, householdId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, REMOVE_HOUSEHOLD_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/RemoveHousehold',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
      data: {
        Id: householdId
      }
    });
  };
};
export var SET_INCLUDED_REMOVED_FILTER = 'SET_HOUSEHOLD_INCLUDED_REMOVED_FILTER';
export var setIncludedRemovedFilter = function setIncludedRemovedFilter(includedFilter) {
  return {
    type: SET_INCLUDED_REMOVED_FILTER,
    payload: includedFilter
  };
};